import { createRouter, createWebHistory } from "vue-router";
import Homepage from "./components/LandingPages/HomePage/Homepage.vue";
import AboutPage from "./components/LandingPages/AboutPage.vue";
import TheContactPage from "./components/LandingPages/TheContactPage.vue";
import NotFound from "./components/NotFound.vue";
import FaqsPage from "./components/LandingPages/FaqsPage.vue";
import RegistrationPage from "./components/LandingPages/RegistrationPage/RegistrationPage.vue";
import TrackNumber from "./components/LandingPages/TrackOrder/TrackNumber.vue";
import TrackInfo from "./components/LandingPages/TrackOrder/TrackInfo.vue";
import DsoAffiliate from "./components/LandingPages/DSO/DsoAffiliate.vue";
import HpScheme from "./components/LandingPages/HpScheme/HpScheme.vue";
import SuccessRegister from "./components/LandingPages/SuccessRegister.vue";
import TermsPolicy from "./components/LandingPages/TermsPolicy.vue";
import DeleteAccount from "./components/LandingPages/DeleteAccount.vue";
import store from "./store";

const routes = [
  { path: "/", name: "home", component: Homepage },
  { path: "/about", name: "about", component: AboutPage },
  { path: "/contact", name: "contact", component: TheContactPage },
  { path: "/delete-account", name: "delete-account", component: DeleteAccount },
  { path: "/faqs", name: "faqs", component: FaqsPage },
  { path: "/hp-scheme", name: "hp-scheme", component: HpScheme },
  { path: "/dso-affiliate", name: "dso-affiliate", component: DsoAffiliate },
  { path: "/register", name: "register", component: RegistrationPage },
  { path: "/trackingnumber", name: "trackingnumber", component: TrackNumber },
  { path: "/terms-policy", name: "terms-policy", component: TermsPolicy },
  {
    path: "/step-one-registration",
    name: "step-one-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/HirePurchaseRegistration/StepOneRegistration.vue"
      ),
  },
  {
    path: "/step-two-registration",
    name: "step-two-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/HirePurchaseRegistration/StepTwoRegistration.vue"
      ),
    beforeEnter: (to, from, next) => {
      let email = localStorage.getItem("hpEmail");
      if (!email) {
        next("/step-one-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/rider-email-verification",
    name: "rider-email-verification",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/HirePurchaseRegistration/RiderEmailVerification.vue"
      ),
    beforeEnter: (to, from, next) => {
      let phone = localStorage.getItem("hpPhone");
      if (!phone) {
        next("/step-one-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/step3-registration",
    name: "step3-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/HirePurchaseRegistration/StepThreeRegistration.vue"
      ),
    beforeEnter: (to, from, next) => {
      let email = localStorage.getItem("hpEmail");
      if (!email) {
        next("/step-one-registration");
      } else {
        next();
      }
    },
  },

  // {path: "/step4-registration", name: 'step4-registration', component:() => import("./components/LandingPages/RegistrationPage/HirePurchaseRegistration/StepFourRegistration.vue"),
  // beforeEnter: (to, from, next) => {
  //     if(store.state.userEmail == "") {
  //         next('/step-one-registration')
  //     } else {
  //         next()
  //     }
  // }
  // },
  {
    path: "/dso-step-one-registration",
    name: "dso-step-one-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRegistration/DsoStepOneRegistration.vue"
      ),
  },
  {
    path: "/dso-step2-registration",
    name: "dso-step2-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRegistration/DsoStep2Registration.vue"
      ),
    beforeEnter: (to, from, next) => {
      let email = localStorage.getItem("dsoEmail");
      if (!email) {
        next("/dso-step-one-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/dso-email-verification",
    name: "dso-email-verification",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRegistration/DsoEmailVerification.vue"
      ),
    beforeEnter: (to, from, next) => {
      let phone = localStorage.getItem("dsoPhone");
      if (!phone) {
        next("/dso-step-one-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/dso-step3-registration",
    name: "dso-step3-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRegistration/DsoStep3Registration.vue"
      ),
    beforeEnter: (to, from, next) => {
      let email = localStorage.getItem("dsoEmail");
      if (!email) {
        next("/dso-step-one-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/dso-step4-registration",
    name: "dso-step4-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRegistration/DsoStep4Registration.vue"
      ),
    beforeEnter: (to, from, next) => {
      let email = localStorage.getItem("dsoEmail");
      if (!email) {
        next("/dso-step-one-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/dso-rider-registration",
    name: "dso-rider-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRiderRegistration/DsoRiderStepOne.vue"
      ),
  },
  {
    path: "/dso-rider-email-verification",
    name: "dso-rider-email-verification",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRiderRegistration/DsoRiderEmailVerification.vue"
      ),
    beforeEnter: (to, from, next) => {
      let phone = localStorage.getItem("riderPhone");
      if (!phone) {
        next("/dso-rider-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/dso-rider-step2-registration",
    name: "dso-rider-step2-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRiderRegistration/DsoRiderStepTwo.vue"
      ),
    beforeEnter: (to, from, next) => {
      let email = localStorage.getItem("riderEmail");
      if (!email) {
        next("/dso-rider-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/dsoRider-step3-registration",
    name: "dsoRider-step3-registration",
    component: () =>
      import(
        "./components/LandingPages/RegistrationPage/DsoRiderRegistration/DsoRiderStepThree.vue"
      ),
    beforeEnter: (to, from, next) => {
      let email = localStorage.getItem("riderEmail");
      if (!email) {
        next("/dso-rider-registration");
      } else {
        next();
      }
    },
  },
  {
    path: "/configuration",
    name: "configuration",
    component: () =>
      import("./components/Admin/Configuration/Configuration.vue"),
  },
  {
    path: "/trackinginfo",
    name: "trackinginfo",
    component: TrackInfo,
    beforeEnter: (to, from, next) => {
      let trackingNumber = localStorage.getItem("trackingNumber");
      if (trackingNumber == "") {
        next("/trackingnumber");
      } else {
        next();
      }
    },
  },
  {
    path: "/success",
    name: "success",
    component: SuccessRegister,
    beforeEnter: (to, from, next) => {
      if (store.state.authenticated == false) {
        next("/register");
      } else {
        next();
      }
    },
  },
  {
    path: "/admin/login",
    name: "admin",
    component: () => import("./components/Admin/AdminLoginAuth.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("./components/Admin/ForgotPassword.vue"),
  },
  {
    path: "/reset-password/:token",
    name: "reset-password",
    component: () => import("./components/Admin/ResetPassword.vue"),
  },
  {
    path: "/admin/dashboard",
    name: "admin-dashboard",
    component: () => import("./components/Admin/Dashboard/Dashboard.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/manage-users",
    name: "users",
    component: () => import("./components/Admin/Users/ManageUsers.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },

  {
    path: "/user-info/:id",
    name: "user-info",
    component: () => import("./components/Admin/Users/UserInfo.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/manage-riders",
    name: "riders",
    component: () => import("./components/Admin/Riders/ManageRiders.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/pending-rider-info/:id",
    name: "pending-rider-info",
    component: () => import("./components/Admin/Riders/PendingRiderInfo.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/approved-rider-info/:id",
    name: "approved-rider-info",
    component: () => import("./components/Admin/Riders/ApprovedRiderInfo.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/riders-info/:id",
    name: "riders-info",
    component: () => import("./components/Admin/Riders/RidersInfo"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/approved-riders",
    name: "approved-rider",
    component: () => import("./components/Admin/Riders/ApprovedRider.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/admin-wallet",
    name: "admin-wallet",
    component: () =>
      import("./components/Admin/AdminWallet/AdminMainWallet/AdminWallet.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/transaction-history",
    name: "transaction-history",
    component: () =>
      import(
        "./components/Admin/AdminWallet/TransactionHistory/TransactionHistory.vue"
      ),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/transaction-info/:id",
    name: "transaction-info",
    component: () =>
      import(
        "./components/Admin/AdminWallet/TransactionHistory/TransactionInfo.vue"
      ),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/manage-admin",
    name: "manage-admin",
    component: () => import("./components/Admin/ManageAdmin/ManageAdmin.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },

  {
    path: "/pending-riders",
    name: "pending-riders",
    component: () => import("./components/Admin/Riders/PendingRiders.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/manage-orders",
    name: "orders",
    component: () => import("./components/Admin/Orders/ManageOrders.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/create-order",
    name: "create-order",
    component: () => import("./components/Admin/Orders/CreateOrder.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/admin/track-order",
    name: "admin-track-order",
    component: () => import("./components/Admin/Orders/TrackOrder.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/reassign-order/:id",
    name: "reassign-order",
    component: () => import("./components/Admin/Orders/ReassignOrder.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/manage-dsos",
    name: "dsos",
    component: () => import("./components/Admin/Dsos/ManageDsos.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/pending-dso",
    name: "pending-dso",
    component: () => import("./components/Admin/Dsos/PendingDsos.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },

  {
    path: "/approved-dsos",
    name: "approved-dsos",
    component: () => import("./components/Admin/Dsos/ApprovedDso.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/dso-info/:id",
    name: "pending-dso-info",
    component: () => import("./components/Admin/Dsos/PendingDsoInfo.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/admin-settings",
    name: "settings",
    component: () => import("./components/Admin/Settings/ProfileSettings.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/manage-admin",
    name: "manage-admin",
    component: () => import("./components/Admin/ManageAdmin/ManageAdmin.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/create-admin",
    name: "create-admin",
    component: () => import("./components/Admin/ManageAdmin/CreateAdmin.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },

  {
    path: "/admin-info/:id",
    name: "admin-info",
    component: () => import("./components/Admin/ManageAdmin/AdminInfo.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/admin-logout",
    name: "logout",
    component: () => import("./components/Admin/Logout/Logout.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/orders/income",
    name: "orders-income",
    component: () => import("./components/Admin/Dashboard/OrdersIncome.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/admin-dashboard",
    redirect: "/admin/dashboard",
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/admin/message",
    name: "message",
    component: () => import("./components/Admin/Messages/Message.vue"),
    beforeEnter: (to, from, next) => {
      const user = localStorage.getItem("user");
      if (!user) {
        next({
          path: "/admin/login",
        });
        return;
      } else {
        if (store.state.isUserAuthenticated) {
          next();
        } else if (user) {
          next();
        }
      }
    },
  },
  {
    path: "/email-center/:id",
    name: "email-center",
    component: () =>
      import("./components/Admin/Messages/SendEmail/AdminCenter.vue"),
    props: true,
  },
  {
    path: "/network-error",
    name: "network-error",
    component: () => import("./components/Admin/ConnectionLost.vue"),
  },

  { path: "/:catchAll(.*)", name: "not-found", component: NotFound },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
// if(!navigator.onLine) {
// console.log("first")
//    router.push('/network-error')
// }

// store.dispatch('fetchAccessToken');
// if (to.fullPath === '/users') {
//   if (!store.state.accessToken) {
//     next('/login');
//   }
// }
// if (to.fullPath === '/login') {
//   if (store.state.accessToken) {
//     next('/users');
//   }
// }
// next();
//   });

export default router;
